import { Component, Inject, NgModule, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ButtonModule } from '../button/button.module';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Componente modal para mostrar al usuario el PIN o PUK,
 * mostrando información relevante y permitiendo cerrar el diálogo.
 *
 * @remarks
 * Este componente es `standalone` e importa módulos para traducción,
 * botones y funcionalidades comunes de Angular.
 *
 * @example
 * ```html
 * <app-pinpuk-modal [data]="{ message: 'Introduce tu PIN' }"></app-pinpuk-modal>
 * ```
 */
@Component({
  selector: 'app-pinpuk-modal',
  templateUrl: './pinpuk-modal.component.html',
  standalone: true,
  imports: [
    TranslateModule,
    ButtonModule,
    CommonModule
  ]
})
export class PinPukModalComponent {
  /** Router inyectado para navegación si es necesario */
  router = inject(Router);

  /**
   * Crea una instancia de PinPukModalComponent.
   * @param dialog Referencia al diálogo actual para control de cierre.
   * @param data Datos inyectados en el modal (como mensajes o configuraciones).
   */
  constructor(
    public dialog: MatDialogRef<PinPukModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  /**
   * Cierra el modal, retornando `false`.
   */
  close(): void {
    this.dialog.close(false);
  }
}
